import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

import { Helmet } from 'react-helmet'

import NavbarInteractive from '../components/navbar-interactive'
import BlogCardBlogs from '../components/blog-card-blogs'
import Footer from '../components/footer'
import './blog.css'

const Blog = (props) => {
  return (
    <div className="blog-container">
      <Helmet>
        <title>Blog - marjangerrits.nl</title>
        <meta name="description" content="Blogs over de Tweede Wereldoorlog" />
        <meta property="og:title" content="Blog - marjangerrits.nl" />
        <meta
          property="og:description"
          content="Blogs over de Tweede Wereldoorlog"
        />
      </Helmet>
      <div className="blog-top">
        <NavbarInteractive rootClassName="navbar-interactiveroot-class-name3"></NavbarInteractive>
      </div>
      <div className="blog-blog">
        <div className="blog-blog-titel">
          <h1>Blog</h1>
          <span>Uit het leven gegrepen</span>
        </div>
        <Link to="/gleiwitz" className="blog-navlink10">
          <BlogCardBlogs
            text={
              <Fragment>
                <span className="blog-text12">
                  <span className="blog-text13">
                    Mijn dubbelroman over de Tweede Wereldoorlog, die nu door de
                    redacteur wordt geredigeerd, gaat niet alleen over de
                    ontberingen van een Nederlander, maar laat ook de andere
                    kant zien. Hoe was het voor een Duitse jongen in die tijd? 
                  </span>
                  <br className="blog-text14"></br>
                  <br className="blog-text15"></br>
                  <span className="blog-text16">
                    Foto:
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <a
                    href="https://nl.wikipedia.org/wiki/Radiotoren_van_Gleiwitz"
                    target="_blank"
                    rel="noreferrer noopener"
                    className="blog-link"
                  >
                    de radiotoren van Gl
                  </a>
                  <span className="blog-text17">eiwitz</span>
                  <br className="blog-text18"></br>
                  <span className="blog-text19">Andrzej Jarczewski</span>
                  <br className="blog-text20"></br>
                  <br className="blog-text21"></br>
                </span>
              </Fragment>
            }
            when="08-10-2024"
            imageSrc="/Blog foto's/gliwice_drewniana_wieza_radiostacji-400h.jpg"
            blogTitle="Echt nep"
            imageSrc1="/Blog foto's/gliwice_drewniana_wieza_radiostacji-400h.jpg"
            description="Echt nep, thema Maand van de Geschiedenis 2024Mijn dubbelroman over de Tweede Wereldoorlog, die nu door de redacteur wordt geredigeerd, gaat niet alleen over de ontberingen van een Nederlander, maar laat ook de andere kant zien. Hoe was het voor een Duitse jongen in die tijd?"
            profileSrc="https://images.unsplash.com/photo-1611232658409-0d98127f237f?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDIzfHxwb3J0cmFpdCUyMHdvbWFufGVufDB8fHx8MTYyNjQ1MDU4MQ&amp;ixlib=rb-1.2.1&amp;h=1200"
            rootClassName="rootClassName7"
            className="blog-gleiwitz-echt-nep"
          ></BlogCardBlogs>
        </Link>
        <Link to="/prora" className="blog-navlink11">
          <BlogCardBlogs
            text={
              <Fragment>
                <span className="blog-text22">
                  Ben je wel eens op het Duitse eiland Rügen geweest? Een
                  prachtig eiland met mooie natuur, bijzondere krijtrotsen en
                  heerlijke stranden. Hitler vond dat kennelijk ook want hij
                  liet in het plaatsje Prora een enorm vakantiecomplex bouwen in
                  de jaren voor de oorlog.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </Fragment>
            }
            when="09-07-2024"
            imageSrc="/prora-400h.jpg"
            blogTitle="Prora. Heeft Hitler toch zijn zin gekregen?"
            imageSrc1="/prora-400h.jpg"
            description="Ben je wel eens op het Duitse eiland Rügen geweest? Een prachtig eiland met mooie natuur, bijzondere krijtrotsen en heerlijke stranden. Hitler vond dat kennelijk ook want hij liet in het plaatsje Prora een enorm vakantiecomplex bouwen in de jaren voor de oorlog. "
            profileSrc="https://images.unsplash.com/photo-1611232658409-0d98127f237f?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDIzfHxwb3J0cmFpdCUyMHdvbWFufGVufDB8fHx8MTYyNjQ1MDU4MQ&amp;ixlib=rb-1.2.1&amp;h=1200"
            rootClassName="rootClassName10"
            className="blog-prora"
          ></BlogCardBlogs>
        </Link>
        <Link to="/walking-in-his-clogs" className="blog-navlink12">
          <BlogCardBlogs
            text={
              <Fragment>
                <span className="blog-text23">
                  Dat heb ik gedaan, een mijl in hun klompen gelopen. En ze
                  hadden niet deze mooie zachte exemplaren die mijn voeten in de
                  winter warm houden. Nee, mijn vader en schoonvader moesten in
                  de oorlog slechtpassende houten schoenen aan.
                </span>
              </Fragment>
            }
            when="30-01-2024"
            imageSrc="/Blog foto's/roze%20klompen-400h.jpg"
            blogTitle="Walk a mile in his clogs"
            imageSrc1="/Blog foto's/roze%20klompen-400h.jpg"
            description="Dat heb ik gedaan, een mijl in hun klompen gelopen. En ze hadden niet deze mooie zachte exemplaren die mijn voeten in de winter warm houden. Nee, mijn vader en schoonvader moesten in de oorlog slechtpassende houten schoenen aan."
            profileSrc="https://images.unsplash.com/photo-1611232658409-0d98127f237f?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDIzfHxwb3J0cmFpdCUyMHdvbWFufGVufDB8fHx8MTYyNjQ1MDU4MQ&amp;ixlib=rb-1.2.1&amp;h=1200"
            rootClassName="rootClassName9"
            className="blog-walk-a-mile"
          ></BlogCardBlogs>
        </Link>
        <Link to="/vip" className="blog-navlink13">
          <BlogCardBlogs
            text={
              <Fragment>
                <span className="blog-text24">
                  Nou, ik wel. En het bracht een wirwar aan gevoelens met zich
                  mee. Het gebeurde tijdens een reis naar de plekken in
                  Frankrijk waar mijn schoonvader tijdens de Tweede Wereldoorlog
                  geweest is.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </Fragment>
            }
            when="28-09-2023"
            imageSrc="/Blog foto's/arras-400h.jpg"
            blogTitle="Ben jij wel eens als VIP uitgenodigd?"
            imageSrc1="/Blog foto's/arras-400h.jpg"
            description="Nou, ik wel. En het bracht een wirwar aan gevoelens met zich mee. Het gebeurde tijdens een reis naar de plekken in Frankrijk waar mijn schoonvader tijdens de Tweede Wereldoorlog geweest is. "
            profileSrc="https://images.unsplash.com/photo-1611232658409-0d98127f237f?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDIzfHxwb3J0cmFpdCUyMHdvbWFufGVufDB8fHx8MTYyNjQ1MDU4MQ&amp;ixlib=rb-1.2.1&amp;h=1200"
            rootClassName="rootClassName8"
            className="blog-vip"
          ></BlogCardBlogs>
        </Link>
        <Link to="/u-boot" className="blog-navlink14">
          <BlogCardBlogs
            text={
              <Fragment>
                <span className="blog-text25">
                  We staan letterlijk stil als we het U-Boot-Ehrendenkmal (U van
                  Untersee) vlakbij Kiel inlopen. Zo veel herdenkingsstenen.
                  Rijen met nummers van gezonken onderzeeërs in de Eerste en
                  Tweede
                </span>
              </Fragment>
            }
            when="04-07-2023"
            imageSrc="/ehrendenkmal%20klein-400w.jpg"
            blogTitle="Stilstaan in Duitsland"
            imageSrc1="/ehrendenkmal%20klein-400w.jpg"
            description="We staan letterlijk stil als we het U-Boot-Ehrendenkmal (U van Untersee) vlakbij Kiel inlopen. Zo veel herdenkingsstenen. Rijen met nummers van gezonken onderzeeërs in de Eerste en Tweede"
            profileSrc="https://images.unsplash.com/photo-1611232658409-0d98127f237f?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDIzfHxwb3J0cmFpdCUyMHdvbWFufGVufDB8fHx8MTYyNjQ1MDU4MQ&amp;ixlib=rb-1.2.1&amp;h=1200"
            rootClassName="rootClassName6"
            className="blog-u-boot"
          ></BlogCardBlogs>
        </Link>
        <Link to="/vati" className="blog-navlink15">
          <BlogCardBlogs
            text={
              <Fragment>
                <span className="blog-text26">
                  Vandaag is het vijfendertig jaar geleden dat mijn Duitse
                  schoonvader, die net als mijn vader Albert heette, overleden
                  is. Ik had hem graag leren kennen. Niet alleen omdat hij de
                  vader van
                </span>
              </Fragment>
            }
            when="25-05-2023"
            imageSrc="/Blog foto's/albert%20woltjes%20hj-400w.jpg"
            blogTitle="Albert Woltjes 24 juni 1925 - 25 mei 1988"
            imageSrc1="/Blog foto's/albert%20woltjes%20hj-400w.jpg"
            description="Vandaag is het vijfendertig jaar geleden dat mijn Duitse schoonvader, die net als mijn vader Albert heette, overleden is. Ik had hem graag leren kennen. Niet alleen omdat hij de vader van"
            profileSrc="https://images.unsplash.com/photo-1611232658409-0d98127f237f?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDIzfHxwb3J0cmFpdCUyMHdvbWFufGVufDB8fHx8MTYyNjQ1MDU4MQ&amp;ixlib=rb-1.2.1&amp;h=1200"
            rootClassName="rootClassName5"
            className="blog-albert-woltjes"
          ></BlogCardBlogs>
        </Link>
        <Link to="/vader" className="blog-navlink16">
          <BlogCardBlogs
            text={
              <Fragment>
                <span className="blog-text27">
                  Precies tien jaar geleden overleed mijn vader in de leeftijd
                  van 91 jaar. Dat is een mooie leeftijd als je bedenkt dat hij
                  bijna tachtig jaar eerder op het nippertje de Tweede
                  Wereldoorlog heeft overleefd.
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
              </Fragment>
            }
            when="23-02-2023"
            imageSrc="/Blog foto's/albert%20gerrits%20klein-400w.jpg"
            blogTitle="Albert Gerrits 7 april 1921 - 23 februari 2013"
            imageSrc1="/Blog foto's/albert%20gerrits%20klein-400w.jpg"
            description="Precies tien jaar geleden overleed mijn vader in de leeftijd van 91 jaar. Dat is een mooie leeftijd als je bedenkt dat hij bijna tachtig jaar eerder op het nippertje de Tweede Wereldoorlog heeft overleefd. "
            profileSrc="https://images.unsplash.com/photo-1611232658409-0d98127f237f?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDIzfHxwb3J0cmFpdCUyMHdvbWFufGVufDB8fHx8MTYyNjQ1MDU4MQ&amp;ixlib=rb-1.2.1&amp;h=1200"
            rootClassName="rootClassName3"
            className="blog-albert-gerrits"
          ></BlogCardBlogs>
        </Link>
        <Link to="/onderzoek-rad" className="blog-navlink17">
          <BlogCardBlogs
            text={
              <Fragment>
                <span className="blog-text28">
                  Wat heeft de kerstmarkt in Bremen met mijn onderzoek te maken?
                  Nou, helemaal niets dus. We waren voor een familiefeestje in
                  Bremen en hebben daarna de kerstmarkt bezocht. Want de
                  kerstmarkt in ...
                </span>
              </Fragment>
            }
            when="17-12-2022"
            imageSrc="/Blog foto's/onderzoek%20in%20duitsland-400h.webp"
            blogTitle="Op onderzoek in Duitsland"
            imageSrc1="/Blog foto's/onderzoek%20in%20duitsland-400h.webp"
            description="Wat heeft de kerstmarkt in Bremen met mijn onderzoek te maken?  Nou, helemaal niets dus. We waren voor een familiefeestje in Bremen en hebben daarna de kerstmarkt bezocht. Want de kerstmarkt in  ..."
            profileSrc="https://images.unsplash.com/photo-1531123897727-8f129e1688ce?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDE0fHxwb3J0cmFpdCUyMHdvbWFufGVufDB8fHx8MTYyNjQ1MDU4MQ&amp;ixlib=rb-1.2.1&amp;h=1200"
            rootClassName="rootClassName2"
            className="blog-onderzoek-rad"
          ></BlogCardBlogs>
        </Link>
        <Link to="/proeverij" className="blog-navlink18">
          <BlogCardBlogs
            text={
              <Fragment>
                <span className="blog-text29">
                  Kamp Amersfoort organiseert een proeverij. Terwijl we erheen
                  rijden denk ik aan mijn vader die er een week of zes gevangen
                  heeft gezeten in de Tweede Wereldoorlog. Wat kreeg hij toen te
                  eten?
                </span>
              </Fragment>
            }
            when="2-12-2022"
            imageSrc="/Blog foto's/smeerstations-400h.jpg"
            blogTitle="Een bijzondere proeverij"
            imageSrc1="/Blog foto's/smeerstations-400h.jpg"
            description="Kamp Amersfoort organiseert een proeverij. Terwijl we erheen rijden denk ik aan mijn vader die er een week of zes gevangen heeft gezeten in de Tweede Wereldoorlog. Wat kreeg hij toen te eten?"
            profileSrc="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDExfHxwb3J0cmFpdCUyMHdvbWFufGVufDB8fHx8MTYyNjQ1MDU4MQ&amp;ixlib=rb-1.2.1&amp;h=1200"
            rootClassName="rootClassName"
            className="blog-een-bijzondere-proeverij"
          ></BlogCardBlogs>
        </Link>
        <Link to="/moeder" className="blog-navlink19">
          <BlogCardBlogs
            text={
              <Fragment>
                <span className="blog-text30">
                  Ze denken dat ik gek ben, maar dat is niet zo. Elke avond
                  komen ze. Ik zie ze toch. Vanuit mijn bed kan ik net door de
                  halfopen slaapkamerdeur naar de woonkamer kijken. Precies daar
                  staat ...
                </span>
              </Fragment>
            }
            when="30-10-2022"
            imageSrc="/Blog foto's/moeder%20copy-400w.jpg"
            blogTitle="Moeder"
            imageSrc1="/Blog foto's/moeder%20copy-400w.jpg"
            description="Ze denken dat ik gek ben, maar dat is niet zo. Elke avond komen ze. Ik zie ze toch. Vanuit mijn bed kan ik net door de halfopen slaapkamerdeur naar de woonkamer kijken. Precies daar staat ..."
            profileSrc="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDExfHxwb3J0cmFpdCUyMHdvbWFufGVufDB8fHx8MTYyNjQ1MDU4MQ&amp;ixlib=rb-1.2.1&amp;h=1200"
            rootClassName="rootClassName4"
            className="blog-moeder"
          ></BlogCardBlogs>
        </Link>
        <Link to="/heilige-wandelingen" className="blog-navlink20">
          <BlogCardBlogs
            text={
              <Fragment>
                <span className="blog-text31">
                  Nieuwe rugzak, oude wandelschoenen, autolampen bestickerd. Met
                  de ferry gaan we naar Engeland. Links houden, links houden,
                  luidt de nieuwe mantra in mijn hoofd. Een knusse cottage in
                  Salisbury ...
                </span>
              </Fragment>
            }
            when="30-09-2022"
            imageSrc="/Blog foto's/boom-400h.webp"
            blogTitle="Heilige wandelingen"
            imageSrc1="/Blog foto's/boom-400h.webp"
            description="Nieuwe rugzak, oude wandelschoenen, autolampen bestickerd. Met de ferry gaan we naar Engeland. Links houden, links houden, luidt de nieuwe mantra in mijn hoofd. Een knusse cottage in Salisbury ..."
            profileSrc="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixid=Mnw5MTMyMXwwfDF8c2VhcmNofDExfHxwb3J0cmFpdCUyMHdvbWFufGVufDB8fHx8MTYyNjQ1MDU4MQ&amp;ixlib=rb-1.2.1&amp;h=1200"
            rootClassName="rootClassName1"
            className="blog-heilige-wandelingen"
          ></BlogCardBlogs>
        </Link>
      </div>
      <Footer rootClassName="footerroot-class-name7"></Footer>
    </div>
  )
}

export default Blog
